import UrlBuilder from "../services/url.builder";

class OfferChoiceController {
  constructor($timeout, $scope, $http, UtilsService) {
    var self = this;

    self.UtilsService = UtilsService;

    self.city = null;
    self.cities = null;
    self.start = null;
    self.startValue = null;
    self.startStudies = null;
    self.startStudiesHide = false;
    self.startStudiesDisabled = true;
    self.level = null;
    self.levels = null;
    self.levelsHide = false;
    self.levelsDisabled = true;
    self.field = null;
    self.fields = null;
    self.fieldsHide = false;
    self.fieldsDisabled = true;
    self.specialty = null;
    self.specialties = null;
    self.specialtiesHide = true;
    self.specialtiesDisabled = true;
    self.specialization = null;
    self.specializations = null;
    self.specializationsHide = true;
    self.specializationsDisabled = true;
    self.mode = null;
    self.modeValue = null;
    self.modes = null;
    self.modesHide = false;
    self.modesDisabled = true;
    self.modesPlaceholder = 'TRYB STUDIÓW';
    self.studyLanguage = null;
    self.studyLanguages = null;
    self.studyLanguagesHide = true;
    self.studyLanguagesDisabled = true;
    self.formOfferChoiceInvalid = true;
    self.enableApiCalls = true;
    self.avilableLanguages = ['polish', 'english', 'czech', 'ukrainian', 'german'];
    self.formula = null;
    self.formulas = null;
    self.formulaDisabled = true;

    self.state = {
      activeCollapse: true
    };

    self.guidedGroupUrl = null;

    self.init = function (enableApiCalls, guidedGroupUrl = null) {
      self.guidedGroupUrl = guidedGroupUrl;

      if (self.UtilsService.language === 'pl') {
          self.state.activeCollapse = true;
      } else {
          self.state.activeCollapse = false;
      }

      self.enableApiCalls = enableApiCalls;
      if (enableApiCalls === false) {
          self.formOfferChoiceInvalid = false;
      }

      self.loadCities();

      if (typeof window.formValues === 'object') {
        if (window.formValues.city) {
          self.city = window.formValues.city;
          self.cities = [window.formValues.city];
          if (!window.formValues.studyStart) {
            self.changedCity();
          }
        }
        if (window.formValues.studyStart && window.formValues.studyStartLabel) {
          self.startValue = window.formValues.studyStart;
          self.start = window.formValues.studyStart;
          self.startStudies = {};
          self.startStudies[self.startValue] = window.formValues.studyStartLabel;
          self.startStudiesHide = true;
          self.startStudiesDisabled = false;
        }
        if (window.formValues.degree && window.formValues.degreeLabel) {
          self.level = window.formValues.degree;
          self.levels = {};
          self.levels[self.level] = window.formValues.degreeLabel;
          self.levelsDisabled = false;
        }
        if (window.formValues.studyField) {
          self.field = window.formValues.studyField;
          self.fields = {};
          self.fields[self.field] = window.formValues.studyField;
          self.fieldsDisabled = false;
        }
        if (window.formValues.speciality) {
          self.specialty = window.formValues.speciality;
          self.specialties = {};
          self.specialties[self.specialty] = window.formValues.speciality;
          self.specialtiesDisabled = false;
          self.specialtiesHide = false;
        }
        if (window.formValues.specialization) {
          self.specialization = window.formValues.specialization;
          self.specializations = [window.formValues.specialization];
          self.specializationsDisabled = false;
          self.specializationsHide = false;
        }
        if (window.formValues.mode && window.formValues.modeLabel) {
          self.mode = window.formValues.mode;
          self.modes = {};
          self.modes[self.mode] = window.formValues.modeLabel;
          self.modesDisabled = false;
          self.modesHide = false;
        }
        if (window.formValues.leadingLanguage) {
          self.studyLanguage = window.formValues.leadingLanguage;
          self.studyLanguages = [window.formValues.leadingLanguage];
          self.studyLanguagesDisabled = false;
          self.studyLanguagesHide = false;
        }
        if (window.formValues.formula) {
          self.changeLanguage(true);
          self.formula = window.formValues.formula;
          self.formulas = {};
          self.formulas[self.formula] = window.formValues.formulaLabel;
          self.formulaDisabled = false;
        }
      }
    };

    self.loadCities = function () {
      if (self.enableApiCalls === false) {
        return;
      }

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/cities',
            { url: self.guidedGroupUrl }
        )
      }).then(function successCallback(response) {
        self.cities = response.data;

        var keys = Object.keys(response.data);
        if (keys.length === 1) {
          self.city = self.cities[keys[0]];
          self.changedCity();
        }

        return self.cities;
      }, function errorCallback(response) {
      });
    };

    self.specializationPlaceholder = function () {
      if (
        (self.city === 'Uniwersytet WSB Merito Wrocław' || self.city === 'Uniwersytet WSB Merito Poznań')
        && self.field
        && self.field.toLowerCase() === 'filologia'
      ) {
        return Translator.trans('recruitment.form.study_specialization');
      }

      return Translator.trans('recruitment.form.specialization');
    };

    self.changedCity = function () {

      if (self.enableApiCalls === false) {
          return;
      }

      self.start = null;
      self.startValue = null;
      self.level = null;
      self.field = null;
      self.specialty = null;
      self.specialization = null;

      self.mode = null;
      self.studyLanguage = null;

      self.startStudies = null;
      self.levels = null;
      self.fields = null;
      self.specialties = null;
      self.specializations = null;
      self.modes = null;
      self.studyLanguages = null;

      self.startStudiesDisabled = false;
      self.levelsDisabled = true;
      self.fieldsDisabled = true;
      self.modesDisabled = true;
      self.studyLanguagesDisabled = true;
      self.specializationsDisabled = true;


      self.specialtiesHide = true;
      self.specializationsHide = true;

      self.formOfferChoiceInvalid = true;

      self.modesPlaceholder = 'TRYB STUDIÓW';

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/study-start',
            {
                city: self.city,
                url: self.guidedGroupUrl
              }
            ),
      }).then(function successCallback(response) {
        self.startStudies = response.data;

        if (Object.keys(response.data).length < 2) {
          self.startStudiesHide = true;
          self.startValue = Object.keys(response.data)[0] || ' ';
          self.start = response.data[self.startValue];
          self.changeStartStudies();
        } else {
          self.startStudiesHide = false;
        }
      });
      window.dataLayer.push({'city': self.city});
    };

    self.citiesDisabled = function() {
      return !self.cities || self.cities.length <= 1;
    };

    self.loadStartStudies = function () {
      return self.startStudies;
    };

    self.changeStartStudies = function () {
      if (self.enableApiCalls === false) {
          return;
      }
      self.level = null;
      self.field = null;
      self.specialty = null;
      self.mode = null;
      self.studyLanguage = null;

      self.levels = null;
      self.fields = null;
      self.specialties = null;
      self.modes = null;
      self.studyLanguages = null;

      self.levelsDisabled = false;
      self.fieldsDisabled = true;
      self.modesDisabled = true;
      self.studyLanguagesDisabled = true;

      self.specialtiesHide = true;

      self.formOfferChoiceInvalid = true;

      self.specialization = null;
      self.specializations = null;
      self.specializationsHide = true;
      self.specializationsDisabled = true;

      self.modesPlaceholder = 'TRYB STUDIÓW';

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/degries',
            {
                city: self.city,
                study_start: self.startValue,
                url: self.guidedGroupUrl
              }
          ),
      }).then(function successCallback(response) {
        self.levelsDisabled = false;
        self.levels = response.data;
        var keys = Object.keys(response.data);
        if (keys.length === 1) {
          self.level = keys[0];
          self.changeLevel();
        } else if (keys.length === 0) {
          self.level = '';
          self.changeLevel();
        }
      });
    };

    self.loadLevel = function () {
      return self.levels;
    };
    self.changeLevel = function () {
      if (self.enableApiCalls === false) {
          return;
      }

      self.field = null;
      self.specialty = null;
      self.mode = null;
      self.studyLanguage = null;

      self.fields = null;
      self.specialties = null;
      self.modes = null;
      self.studyLanguages = null;

      self.fieldsDisabled = false;
      self.modesDisabled = true;
      self.studyLanguagesDisabled = true;

      self.formOfferChoiceInvalid = true;

      self.specialization = null;
      self.specializations = null;
      self.specializationsHide = true;
      self.specializationsDisabled = true;

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      self.specialtiesHide = true;
      if (self.level === 'PG') {
        self.modesPlaceholder = 'FORMA STUDIOWANIA';
      } else {
        self.modesPlaceholder = 'TRYB STUDIÓW';
      }

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/study-field',
            {
                city: self.city,
                study_start: self.startValue,
                degree: self.level,
                url: self.guidedGroupUrl
              }
          ),
      }).then(function successCallback(response) {
        self.fields = response.data;
        self.fieldsDisabled = false;
        var keys = Object.keys(response.data);
        if (keys.length === 1) {
          self.field = keys[0];
          self.changeField();
        } else if (keys.length === 0) {
          self.field = '';
          self.changeField();
        }
      });
    };

    self.loadFields = function () {
      return self.fields;

    };
    self.changeField = function () {
      if (self.enableApiCalls === false) {
          return;
      }
      self.specialty = null;
      self.mode = null;
      self.studyLanguage = null;

      self.specialties = null;
      self.modes = null;
      self.studyLanguages = null;

      self.modesDisabled = true;
      self.studyLanguagesDisabled = true;

      self.specialtiesHide = true;

      self.formOfferChoiceInvalid = true;
      self.specialization = null;
      self.specializations = null;
      self.specializationsHide = true;
      self.specializationsDisabled = true;

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/speciality',
            {
                city: self.city,
                study_start: self.startValue,
                degree: self.level,
                study_field: encodeURIComponent(self.field),
                url: self.guidedGroupUrl
            }
        ),
      }).then(function successCallback(response) {
        self.specialtiesDisabled = false;
        self.specialties = response.data;
        var keys = Object.keys(response.data);
        if (keys.length === 0) {
          self.specialty = '';
          self.changeSpecialty();
        } else if (keys.length === 1) {
          self.specialty = keys[0];
          self.specialtiesHide = false;
          self.changeSpecialty();
        } else {
          self.specialtiesHide = false;
        }

      });
    };
    self.loadSpecialty = function () {
      return self.specialties;
    };
    self.changeSpecialty = function () {
      if (self.enableApiCalls === false) {
        return;
      }

      self.mode = null;
      self.studyLanguage = null;
      self.specialization = null;

      self.modes = null;
      self.studyLanguages = null;
      self.specializations = null;

      self.modesDisabled = true;
      self.studyLanguagesDisabled = true;
      self.specializationsDisabled = true;

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      self.formOfferChoiceInvalid = true;
      $http({
        method: 'GET',
        url: self.getUrl(
            'api/specialization',
            {
                city: self.city,
                study_start: self.startValue,
                degree: self.level,
                study_field: encodeURIComponent(self.field),
                speciality: encodeURIComponent(self.specialty),
                url: self.guidedGroupUrl
            }
        ),
      }).then(function successCallback(response) {
        self.specializations = response.data;
        self.specializationsDisabled = false;

        if (response.data.length === 1) {
          self.specialization = response.data[0] || '';
        }

        if(response.data.length === 1){
          self.changeSpecialization();
        }

        if (response.data.length < 1) {
          self.specializationsHide = true;
          self.specialization = '';
          self.changeMode();
        }
        if (response.data.length >= 1) {
          self.specializationsHide = false;
        }
        if (response.data.length < 2) {
          self.changeSpecialization();
        }


      });
    };
    self.loadSpecializations = function () {
      return self.specializations;
    };

    self.changeSpecialization = function () {
      if (self.enableApiCalls === false) {
          return;
      }

      self.mode = null;
      self.studyLanguage = null;

      self.modes = null;
      self.studyLanguages = null;

      self.modesDisabled = false;
      self.studyLanguagesDisabled = true;
      self.formOfferChoiceInvalid = true;

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/mode',
            {
              city: self.city,
              study_start: self.startValue,
              degree: self.level,
              study_field: encodeURIComponent(self.field),
              speciality: encodeURIComponent(self.specialty),
              specialization: encodeURIComponent(self.specialization),
              url: self.guidedGroupUrl
            }
        ),
      }).then(function successCallback(response) {
        self.modes = response.data;
        self.modesDisabled = false;

        if (Object.keys(response.data).length < 2) {
          self.modeValue = Object.keys(response.data)[0] || ' ';
          self.mode = self.modeValue;
          self.changeMode();
        }

      });
    };

    self.loadMode = function () {

      // Use timeout to simulate a 650ms request.
      return self.modes;
    };
    self.changeMode = function () {
      if (self.enableApiCalls === false) {
          return;
      }

      self.studyLanguage = null;
      self.studyLanguages = null;
      self.studyLanguagesDisabled = false;
      self.formOfferChoiceInvalid = false;

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/leading-language',
            {
              city: self.city,
              study_start: self.startValue,
              degree: self.level,
              study_field: encodeURIComponent(self.field),
              speciality: encodeURIComponent(self.specialty),
              specialization: encodeURIComponent(self.specialization),
              url: self.guidedGroupUrl
            }
        ),
      }).then(function successCallback(response) {
        self.studyLanguages = response.data;

        if (response.data.length < 2) {
          self.studyLanguage = response.data[0] || '';
          self.studyLanguagesHide = true;

          self.changeLanguage();
        }
      });
    };
    self.loadLanguage = function () {
      return self.studyLanguages;
    };

    self.showField = function()
    {
      if (self.level === window.statics.mba && (self.fields === null || self.fields.length === 1)) {
        return false;
      }

      return !self.fieldsHide;
    };

    self.showSpecialty = function()
    {
        if (self.level === window.statics.mba && (self.levels === null || self.levels.length === 1)) {
        return false;
      }

      return !self.specialtiesHide;
    };

    self.showMode = function()
    {
      if (self.level === window.statics.mba && (self.modes === null || Object.keys(self.modes).length === 1)) {
        return false;
      }

      return !self.modesHide;
    };

    self.studyLanguageFlag = function(language, flagLanguage)
    {
      if (!self.avilableLanguages.includes(language)) {
        language = window.formValues.leadingLanguage;
      }

      if (language) {
        return language.toLowerCase() === flagLanguage;
      }

      return null;
    };

    self.loadFormulas = function () {
      return self.formulas;
    };

    self.changeLanguage = function () {
      if (self.enableApiCalls === false) {
        return;
      }

      self.formula = null;
      self.formuls = null;
      self.formulaDisabled = true;

      if (self.enableApiCalls === false) {
        return;
      }

      self.formulaDisabled = false;

      $http({
        method: 'GET',
        url: self.getUrl(
            'api/formula',
            {
              city: self.city,
              study_start: self.startValue,
              degree: self.level,
              study_field: encodeURIComponent(self.field),
              speciality: encodeURIComponent(self.specialty),
              specialization: encodeURIComponent(self.specialization),
              mode: encodeURIComponent(self.mode),
              leadingLanguage: encodeURIComponent(self.studyLanguage),
              url: self.guidedGroupUrl
            }
        ),
      }).then(function successCallback(response) {
        self.formulas = response.data;

        if (Object.keys(self.formulas).length < 2) {

          self.formula = Object.keys(self.formulas)[0] || null;
        }
      });
    };

    self.getEncodedValue = function (value) {
      return value ? encodeURIComponent(value) : '';
    };

    self.getUrlPart = function () {
      return self.guidedGroupUrl ? '&url=' + self.getEncodedValue(self.guidedGroupUrl) : '';
    }

    self.getUrl = function (baseUrl, parameters) {
      if ('url' in parameters && null === parameters.url) {
        delete parameters.url;
      }

      return new UrlBuilder(baseUrl).setQueryParams(parameters).build();
    }
  }
}

OfferChoiceController.$inject = ['$timeout', '$scope', '$http', 'UtilsService'];

export default OfferChoiceController;
